import React, { Suspense, FC } from 'react';
import { useInView } from 'react-hook-inview';
import { useTranslation } from 'react-i18next';

import DataCardsBg from '../../../images/company/data-cards-bg.png';
import NerdLogo from '../../../images/company/nerd-logo.png';
import {
  DataStyled,
  LeftColumn,
  RightColumn,
  Title,
  CardsContainer,
  Card,
} from './style';

interface Props {}

const Data: FC<Props> = () => {
  const { t } = useTranslation();
  const [targetRef, isInViewport] = useInView({
    unobserveOnEnter: true,
    threshold: 0.5,
  });
  return (
    <Suspense fallback={<div />}>
      <DataStyled>
        <div ref={targetRef} className="container">
          <LeftColumn
            className={
              isInViewport ? 'animate__animated animate__fadeInLeft' : 'hide'
            }
          >
            <img src={NerdLogo} alt="logo" />
            <Title
              dangerouslySetInnerHTML={{
                __html: t('CompanyDataTitle'),
              }}
            />
          </LeftColumn>
          <RightColumn>
            <img
              src={DataCardsBg}
              alt="logo"
              className={
                isInViewport ? 'animate__animated animate__fadeIn' : 'hide'
              }
            />
            <CardsContainer>
              <Card
                className={
                  isInViewport
                    ? 'animate__animated animate__fadeInRight animate__fadeIn animate__faster animate__delay-1s'
                    : 'hide'
                }
              >
                <div
                  className="inner"
                  dangerouslySetInnerHTML={{
                    __html: t('CompanyDataCard1'),
                  }}
                />
              </Card>
              <Card
                className={
                  isInViewport
                    ? 'animate__animated animate__fadeInRight animate__fadeIn animate__faster animate__delay-2s'
                    : 'hide'
                }
              >
                <div
                  className="inner"
                  dangerouslySetInnerHTML={{
                    __html: t('CompanyDataCard2'),
                  }}
                />
              </Card>
              <Card
                className={
                  isInViewport
                    ? 'animate__animated animate__fadeInRight animate__fadeIn animate__faster animate__delay-3s'
                    : 'hide'
                }
              >
                <div
                  className="inner"
                  dangerouslySetInnerHTML={{
                    __html: t('CompanyDataCard3'),
                  }}
                />
              </Card>
            </CardsContainer>
          </RightColumn>
        </div>
      </DataStyled>
    </Suspense>
  );
};

export default Data;
